// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__1ZOcQ","radioRow":"SimpleQuestionBuilderModal_radioRow__zzb7i"};